"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBannerTitle = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component for displaying title in TopBanner. For falsy value in `title` returns `null`.
 */
const TopBannerTitle = ({
  imageUrl,
  title,
  extraLongHeadline,
  hasBreadcrumbs
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!title) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TitleRoot, {
    "data-testid": getTestId(_constants.TOP_BANNER_TITLE),
    paddingOnlyOnTop: !!imageUrl,
    hasBreadcrumbs: hasBreadcrumbs,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Title, {
      variant: "h2",
      component: "h2",
      extraLongHeadline: extraLongHeadline,
      children: title
    })
  });
};
exports.TopBannerTitle = TopBannerTitle;
//# sourceMappingURL=TopBannerTitle.js.map